import type { KyuseiPart } from '../lib/types';
import { StarRating } from './StarRating';
import { CategoryGrid } from './CategoryGrid';
import { SourceFooter } from './SourceFooter';

interface Props {
  data: KyuseiPart;
}

export function KyuseiCard({ data }: Props) {
  return (
    <section className="card mt-4 mx-4">
      <header className="flex items-baseline gap-3">
        <span className="label">第1部</span>
        <h2 className="card-title">九星気学</h2>
      </header>
      <div className="mt-2 flex items-center gap-3">
        <StarRating value={data.rating} label={data.ratingLabel} />
      </div>
      {data.luckyDirection && (
        <p className="mt-3 text-xs">
          <span className="label mr-2">吉方位</span>
          <span className="text-ink-700 dark:text-ink-100">{data.luckyDirection}</span>
        </p>
      )}
      <CategoryGrid categories={data.categories} />
      <SourceFooter sources={data.sources} />
    </section>
  );
}
